import { Component, OnInit } from '@angular/core'

@Component({
    selector: './setup-menu-preferences',
    templateUrl: './setup-menu-preferences.component.html',
    styleUrls: ['../../../../../help.component.css']
})

export class SetupMenuPreferencesComponent implements OnInit {

    ngOnInit() {

    }
}